export const rules = [
    (v:any) => !!v || 'Required',
    (v:any) => {
        const pattern = /^$|(\s*|\d+)/
        return pattern.test(v) || 'Invalid input.'
    },
    (v:any) =>
        (v.length <= 100) ||
        "Text must be 100 characters or less"
]



